import React from 'react'
import { connect } from 'react-redux'
import { Classes, Dialog, Button } from '@blueprintjs/core'
import {
    asyncUpdateRunbookSession,
    getActiveRunbook,
    collectHiddenActionUids,
} from 'src/store/modules/runbooks'
import {
    toggleControl,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'
import { statusOptions } from 'src/store/modules/runbooks/actions'

const mapStateToProps = (state) => {
    return {
        runbook: getActiveRunbook(state),
        openAction: state.ui.runbook.controls.singleOpenAction,
        changingStatus:
            state.ui.runbook.controls.isConfirmingStatusChangePropagate,
        actionId: state.ui.runbook.actionId,
    }
}

class ConfirmStatusAlertPropagate extends React.Component {
    handleConfirm = (propagate) => () => {
        const { actionId, runbook, openAction } = this.props

        // Collect hidden action UIDs
        const hiddenActionUids = collectHiddenActionUids(runbook?.actions?.byId)

        this.props.asyncUpdate(
            runbook.id,
            [openAction],
            {
                action: statusOptions.byId[actionId].onSelect,
                propagate,
            },
            hiddenActionUids
        )

        this.handleCancel()
    }
    handleCancel = () => {
        this.props.singleEditAction(null)
        this.props.toggleControl('isConfirmingStatusChangePropagate')
    }
    render() {
        const { changingStatus } = this.props

        return (
            <Dialog
                icon="info-sign"
                onClose={this.handleCancel}
                isOpen={changingStatus}
                title="Update Action Status"
            >
                <div className={Classes.DIALOG_BODY}>
                    <p>
                        Would you like to update the status of all related
                        sub-tasks as well?
                    </p>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            onClick={this.handleConfirm(true)}
                        >
                            Yes
                        </Button>
                        <Button
                            intent="primary"
                            large
                            onClick={this.handleConfirm(false)}
                        >
                            No
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default connect(mapStateToProps, {
    toggleControl,
    singleEditAction,
    asyncUpdate: asyncUpdateRunbookSession,
})(ConfirmStatusAlertPropagate)
